import { Component, Input, OnChanges } from '@angular/core';
import { ReactWrapperDirective } from 'src/app/project/directives/react-wrapper-directive';
import DigitalSignature, {
  DigitalSignatureProps,
} from 'react-lib/components/organisms/DigitalSignature';
import { TDigitalSignatureValues } from 'react-lib/components/molecules/AddDigitalSignatureModal';
import { TUser } from '../../user.model';
import { UserSettingsService } from '../user-settings.service';

@Component({
  standalone: true,
  selector: 'pp-user-settings-digital-signature',
  templateUrl: './user-settings-digital-signature.html',
  styleUrls: ['./user-settings-digital-signature.scss'],
  imports: [ReactWrapperDirective],
})
export class UserSettingsDigitalSignatureComponent implements OnChanges {
  @Input() ppUser: TUser;

  DigitalSignature = DigitalSignature;

  private savedSignature: TDigitalSignatureValues | null = null;

  props = this.toProps();

  constructor(private userSettingsService: UserSettingsService) {}

  ngOnChanges(): void {
    this.props = this.toProps();
  }

  private toProps(): DigitalSignatureProps {
    return {
      onSave: this.saveSignature.bind(this),
      onRemove: this.removeSignature.bind(this),
      signature: {
        user: this.savedSignature?.name ?? this.ppUser?.userName ?? '',
        role: this.savedSignature?.role ?? '',
        svg: this.savedSignature?.svg ?? null,
      },
    };
  }

  private saveSignature(formValues: TDigitalSignatureValues): void {
    if (!this.ppUser?.userId) {
      return;
    }

    this.userSettingsService.saveSignature(this.ppUser.userId, formValues).subscribe(() => {
      this.savedSignature = formValues;
      this.props = this.toProps();
    });
  }

  private removeSignature(): void {
    this.savedSignature = null;
    this.props = this.toProps();
  }
}
